import { render, staticRenderFns } from "./AlertSet2.vue?vue&type=template&id=a340cd5a&scoped=true"
import script from "./AlertSet2.vue?vue&type=script&lang=js"
export * from "./AlertSet2.vue?vue&type=script&lang=js"
import style0 from "./AlertSet2.vue?vue&type=style&index=0&id=a340cd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a340cd5a",
  null
  
)

export default component.exports